import { render, staticRenderFns } from "./PageLoad.vue?vue&type=template&id=26163a87&scoped=true&"
var script = {}
import style0 from "./PageLoad.vue?vue&type=style&index=0&id=26163a87&lang=scss&scoped=true&"
import style1 from "./PageLoad.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26163a87",
  null
  
)

export default component.exports